export default {
  externalLink: {
    en: 'Opens in a new window in another service.',
    fi: 'Avataan uuteen ikkunaan ja toiseen palveluun.',
    sv: 'Öppnas i nytt fönster i annan tjänst.'
  },
  loginLink: {
    en: 'Requires to log in.',
    fi: 'Vaatii sisäänkirjautumisen.',
    sv: 'Kräver inloggning.'
  }
};